import { FrontendLogg } from "./apiTypes";
import { post } from "./api.utils";

interface LoggApi {
  opprettLogg: (logg: FrontendLogg, anmeldelseId?: string) => Promise<void>;
}

const loggUrl = "/logg";

export const loggApi: LoggApi = {
  opprettLogg: async (
    logg: FrontendLogg,
    anmeldelseId?: string,
  ): Promise<void> => {
    await post(
      `${loggUrl}${anmeldelseId ? "?anmeldelseId=" + anmeldelseId : ""}`,
      logg,
    );
  },
};
